import { useEffect, useState } from "react";

import API_URL from "../apiConfig";

import "../CSS/feedback.css";


function FeedbackPage() {

    const [name, setName] =
        useState("");

    const [text, setText] =
        useState("");

    const [feedbacks, setFeedbacks] =
        useState([]);

    const [meldung, setMeldung] =
        useState("");

    const [fehler, setFehler] =
        useState("");

    const [isSubmitting, setIsSubmitting] =
        useState(false);


    // ==================================================
    // FREIGEGEBENE FEEDBACKS LADEN
    // ==================================================

    function ladeFeedbacks() {

        fetch(
            `${API_URL}/feedback.php`
        )

            .then((response) => {

                if (!response.ok) {

                    throw new Error(
                        "Feedbacks konnten nicht geladen werden."
                    );
                }

                return response.json();
            })

            .then((daten) => {

                setFeedbacks(daten);
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Laden der Feedbacks:",
                    error
                );
            });
    }


    // ==================================================
    // BEIM START LADEN
    // ==================================================

    useEffect(() => {

        ladeFeedbacks();

    }, []);


    // ==================================================
    // FEEDBACK ABSENDEN
    // ==================================================

    async function handleSubmit(event) {

        event.preventDefault();


        if (isSubmitting) {

            return;
        }


        setMeldung("");
        setFehler("");


        const bereinigterName =
            name.trim();

        const bereinigterText =
            text.trim();


        // ==================================================
        // EINGABEN PRÜFEN
        // ==================================================

        if (
            !bereinigterName ||
            !bereinigterText
        ) {

            setFehler(
                "Bitte Name und Feedback ausfüllen."
            );

            return;
        }


        // ==================================================
        // SPEICHERN
        // ==================================================

        try {

            setIsSubmitting(true);


            const response =
                await fetch(
                    `${API_URL}/feedback.php`,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body: JSON.stringify({
                            name:
                                bereinigterName,

                            text:
                                bereinigterText
                        })
                    }
                );


            const daten =
                await response.json();


            if (!response.ok) {

                throw new Error(
                    daten.error ||
                    "Feedback konnte nicht gespeichert werden."
                );
            }


            // ==================================================
            // FORMULAR LEEREN
            // ==================================================

            setName("");
            setText("");


            // ==================================================
            // ERFOLGSMELDUNG
            // ==================================================

            setMeldung(
                daten.message
            );


            // ==================================================
            // FREIGEGEBENE FEEDBACKS NEU LADEN
            // ==================================================

            ladeFeedbacks();


        } catch (error) {

            setFehler(
                error.message
            );


        } finally {

            setIsSubmitting(false);
        }
    }


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <div className="intro">

                <h1>
                    Feedback
                </h1>

                <p>
                    Ich freue mich über Dein persönliches Feedback
                    zu meiner Webseite.
                </p>

            </div>


            <main className="feedback-main">

                <section className="feedback-formular-bereich">

                    <h2>
                        Dein Feedback
                    </h2>


                    <p>
                        Wenn Du Anregungen, Rückmeldungen oder einen
                        persönlichen Eindruck zu meiner Webseite hast,
                        kannst Du ihn hier gerne hinterlassen.
                    </p>


                    <p className="feedback-hinweis">
                        Dein Beitrag wird erst nach meiner Freigabe
                        auf dieser Seite veröffentlicht.
                    </p>


                    <form
                        className="feedback-formular"
                        onSubmit={handleSubmit}
                    >

                        <label htmlFor="feedback-name">
                            Dein Name
                        </label>


                        <input
                            id="feedback-name"
                            type="text"
                            value={name}
                            maxLength="80"
                            onChange={
                                (event) =>
                                    setName(
                                        event.target.value
                                    )
                            }
                        />


                        <label htmlFor="feedback-text">
                            Dein Feedback
                        </label>


                        <textarea
                            id="feedback-text"
                            value={text}
                            rows="7"
                            maxLength="1500"
                            onChange={
                                (event) =>
                                    setText(
                                        event.target.value
                                    )
                            }
                        />


                        <button
                            type="submit"
                            className="feedback-button"
                            disabled={isSubmitting}
                        >
                            {
                                isSubmitting
                                    ? "Wird gesendet..."
                                    : "Feedback absenden"
                            }
                        </button>

                    </form>


                    {
                        meldung && (

                            <p className="feedback-erfolg">
                                {meldung}
                            </p>

                        )
                    }


                    {
                        fehler && (

                            <p className="feedback-fehler">
                                {fehler}
                            </p>

                        )
                    }

                </section>


                <section className="feedback-liste-bereich">

                    <h2>
                        Das sagen Besucher
                    </h2>


                    {
                        feedbacks.length === 0 ? (

                            <p>
                                Zurzeit sind noch keine Feedbacks
                                veröffentlicht.
                            </p>

                        ) : (

                            <div className="feedback-liste">

                                {
                                    feedbacks.map(
                                        (feedback) => (

                                            <article
                                                className="feedback-beitrag"
                                                key={feedback.id}
                                            >

                                                <div className="feedback-kopf">

                                                    <strong>
                                                        {feedback.name}
                                                    </strong>

                                                    <span>
                                                        {feedback.datum}
                                                    </span>

                                                </div>


                                                <p>
                                                    {feedback.text}
                                                </p>

                                            </article>

                                        )
                                    )
                                }

                            </div>

                        )
                    }

                </section>

            </main>

        </>
    );
}


export default FeedbackPage;